export interface ComicChapter {
  id: string;
  title: string;
  chapterNumber: number;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  description: string;
  coverImage: string;
  rating: number;
  views: string;
  status: '连载中' | '已完结';
  tags: string[];
  chapters: ComicChapter[];
  updateDate: string;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export const categories = [
  { name: '恋爱', slug: 'love', icon: 'ri-heart-line' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { name: '动作', slug: 'action', icon: 'ri-sword-line' },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line' },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '都市', slug: 'urban', icon: 'ri-building-line' },
  { name: '穿越', slug: 'isekai', icon: 'ri-door-open-line' },
  { name: '耽美', slug: 'bl', icon: 'ri-star-line' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '我的野蛮王妃',
    author: '朴熙珍',
    category: '恋爱',
    categorySlug: 'love',
    description: '平凡的女高中生林小夏因为一次意外穿越到了神秘的古代王国，成为了王妃候选人。在这个充满阴谋与浪漫的宫廷中，她必须学会生存，同时面对多位王子之间复杂的情感纠葛。高冷皇太子、温柔二皇子、神秘护卫——谁才是她真正的命运之人？一段跨越时空的浪漫爱情故事就此展开。画风精美，剧情扣人心弦，每一话都让人期待不已！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20style%2C%20romance%20manhwa%2C%20beautiful%20female%20character%20in%20traditional%20palace%20dress%2C%20soft%20warm%20tones%2C%20elegant%20composition%2C%20manga%20style%20illustration%20with%20clean%20lines%20and%20soft%20colors%2C%20light%20cream%20background%2C%20professional%20webtoon%20cover&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    rating: 9.6,
    views: '1280万',
    status: '连载中',
    tags: ['穿越', '宫廷', '浪漫', '逆袭'],
    chapters: Array.from({ length: 86 }, (_, i) => ({
      id: `ch-1-${i + 1}`,
      title: `第${i + 1}话${i < 5 ? [' 命运的相遇', ' 王子的秘密', ' 宫廷初夜', ' 危机四伏', ' 意外的告白'][i] || '' : ''}`,
      chapterNumber: i + 1,
      updateDate: new Date(2026, 7, 4 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
    updateDate: '2026-08-04',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-2',
    title: '剑与魔法之王',
    author: '金道贤',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '在一个魔法与剑术并存的世界里，被世人嘲笑的"最弱魔法师"艾伦意外获得了远古龙王的传承。从此，他的命运发生了翻天覆地的变化。从一个连火球术都放不出的废柴，到能够召唤巨龙、掌握禁咒的最强魔法师。然而，力量的觉醒也引来了黑暗势力的觊觎。艾伦必须保护身边的人，同时揭开自己身世背后的惊天秘密。热血沸腾的战斗场面，宏大壮观的世界观设定，让你沉浸其中！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%2C%20fantasy%20manhwa%2C%20male%20hero%20with%20magic%20sword%2C%20epic%20fantasy%20illustration%2C%20dragon%20in%20background%2C%20cool%20blue%20and%20gold%20tones%2C%20manga%20style%2C%20dynamic%20pose%2C%20clean%20webtoon%20cover%20design%2C%20light%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    rating: 9.4,
    views: '2150万',
    status: '连载中',
    tags: ['魔法', '冒险', '升级', '龙'],
    chapters: Array.from({ length: 120 }, (_, i) => ({
      id: `ch-2-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: new Date(2026, 7, 4 - Math.floor(i / 5)).toISOString().split('T')[0],
    })),
    updateDate: '2026-08-04',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-3',
    title: '暗夜追踪者',
    author: '李允儿',
    category: '悬疑',
    categorySlug: 'mystery',
    description: '首尔深夜的街头，接连发生离奇失踪案。前刑警韩智勋因为一桩未破的悬案离开了警队，却意外卷入了一场更大的阴谋。每一个失踪者都与一个神秘的组织有关联，而线索指向了他以为早已死去的搭档。在真相与谎言交织的迷雾中，韩智勋必须依靠自己的推理能力，一步步揭开隐藏在黑暗中的秘密。紧张刺激的悬疑剧情，层层递进的推理过程，让你的大脑高速运转！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%2C%20mystery%20thriller%20manhwa%2C%20detective%20in%20dark%20alley%2C%20noir%20style%2C%20dramatic%20lighting%2C%20manga%20illustration%2C%20cool%20dark%20tones%20with%20red%20accents%2C%20suspenseful%20atmosphere%2C%20clean%20webtoon%20cover%20design&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    rating: 9.2,
    views: '890万',
    status: '连载中',
    tags: ['推理', '犯罪', '都市', '悬疑'],
    chapters: Array.from({ length: 54 }, (_, i) => ({
      id: `ch-3-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: new Date(2026, 7, 3 - Math.floor(i / 4)).toISOString().split('T')[0],
    })),
    updateDate: '2026-08-03',
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-4',
    title: '校园爆笑日记',
    author: '崔敏浩',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '转学生张小北来到新学校的第一天就闹出了天大的笑话——把校长当成了清洁工大叔！从此，他的校园生活变成了一场接一场的爆笑闹剧。奇葩的同学、严厉又可爱的老师、永远追不到的女神、还有那个处处和他作对的死对头。在这个充满欢笑的校园里，每一天都是新的爆笑篇章。轻松欢乐的日常喜剧，让你笑到停不下来！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%2C%20comedy%20school%20manhwa%2C%20funny%20students%20in%20classroom%2C%20bright%20colorful%20illustration%2C%20chibi%20style%20elements%2C%20energetic%20composition%2C%20manga%20style%2C%20cheerful%20warm%20colors%2C%20clean%20webtoon%20cover%20design&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    rating: 9.0,
    views: '1560万',
    status: '连载中',
    tags: ['校园', '日常', '搞笑', '青春'],
    chapters: Array.from({ length: 98 }, (_, i) => ({
      id: `ch-4-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: new Date(2026, 7, 2 - Math.floor(i / 5)).toISOString().split('T')[0],
    })),
    updateDate: '2026-08-02',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-5',
    title: '都市猎魔人',
    author: '郑宇成',
    category: '动作',
    categorySlug: 'action',
    description: '在繁华都市的阴影之下，隐藏着不为人知的魔物。猎魔人姜宇是最后一代传承者，他白天是普通的咖啡店老板，夜晚则化身为猎魔人，保护着这座城市的安宁。当古老的封印开始松动，越来越多的魔物涌入人间，姜宇必须在维持日常生活和拯救世界之间找到平衡。酣畅淋漓的战斗场面，酷炫的武术招式，让你感受到拳拳到肉的爽快感！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%2C%20action%20manhwa%2C%20urban%20demon%20hunter%2C%20cool%20male%20character%20fighting%20pose%2C%20dynamic%20action%20illustration%2C%20neon%20city%20background%2C%20manga%20style%2C%20fiery%20orange%20and%20dark%20tones%2C%20clean%20webtoon%20cover%20design&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    rating: 9.3,
    views: '1890万',
    status: '连载中',
    tags: ['都市', '战斗', '超能力', '热血'],
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: `ch-5-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: new Date(2026, 7, 1 - Math.floor(i / 4)).toISOString().split('T')[0],
    })),
    updateDate: '2026-08-01',
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-6',
    title: '穿越之绝世神医',
    author: '韩智恩',
    category: '穿越',
    categorySlug: 'isekai',
    description: '现代顶尖外科医生苏晚晴因一场医疗事故穿越到了架空的古代王朝。在这里，她凭借精湛的医术从一介平民女医一步步成为宫廷首席御医。然而，宫廷之中权谋暗涌，她不仅要救死扶伤，还要在各方势力的夹缝中求生存。冷酷王爷、温润太子、神秘药王传人——三段截然不同的感情线交织在一起，让她的穿越之旅充满变数。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%2C%20historical%20isekai%20manhwa%2C%20beautiful%20female%20doctor%20in%20ancient%20Chinese%20style%2C%20elegant%20traditional%20costume%2C%20soft%20pastel%20colors%2C%20manga%20style%20illustration%2C%20romantic%20atmosphere%2C%20clean%20webtoon%20cover%20design&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    rating: 9.5,
    views: '1760万',
    status: '连载中',
    tags: ['穿越', '古风', '医术', '宫廷'],
    chapters: Array.from({ length: 65 }, (_, i) => ({
      id: `ch-6-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: new Date(2026, 7, 3 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
    updateDate: '2026-08-03',
    isHot: false,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 'comic-7',
    title: 'BL恋爱论',
    author: '尹素熙',
    category: '耽美',
    categorySlug: 'bl',
    description: '大学新生李恩浩搬进了学校附近的合租公寓，没想到室友竟然是自己高中时暗恋过的学长江泰熙。两人从最初的尴尬相处，到逐渐产生微妙的感情变化。然而江泰熙已经有了交往多年的女朋友，李恩浩只能把这份感情深深埋在心底。当秘密被揭开的那一天，三个人的关系将何去何从？细腻的情感描写，唯美的画面风格，带你体验一段刻骨铭心的青春爱恋。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%2C%20BL%20romance%20manhwa%2C%20two%20handsome%20young%20men%20in%20university%20setting%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20manga%20style%2C%20gentle%20pastel%20colors%2C%20clean%20webtoon%20cover%20design&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    rating: 9.1,
    views: '970万',
    status: '连载中',
    tags: ['校园', '暗恋', '青春', '纯爱'],
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: `ch-7-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: new Date(2026, 7, 2 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
    updateDate: '2026-08-02',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 'comic-8',
    title: '帝王的独宠',
    author: '安智贤',
    category: '恋爱',
    categorySlug: 'love',
    description: '她是相府最不受宠的庶女，他是权倾天下的冷酷帝王。一场政治联姻将两人的命运紧紧绑在一起。本以为婚后不过是相敬如宾的陌路人，谁知帝王竟对这个不起眼的小女子产生了浓厚的兴趣。从最初的利用到不知不觉的沦陷，帝王的心墙被她一点点瓦解。然而后宫之中暗潮汹涌，前朝之上风云变幻，他们的爱情能否经得起重重考验？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%2C%20historical%20romance%20manhwa%2C%20emperor%20and%20empress%20in%20palace%2C%20luxurious%20traditional%20costumes%2C%20golden%20and%20red%20color%20scheme%2C%20manga%20style%2C%20romantic%20and%20dramatic%2C%20clean%20webtoon%20cover%20design&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    rating: 9.7,
    views: '2340万',
    status: '连载中',
    tags: ['古风', '宫斗', '宠文', '逆袭'],
    chapters: Array.from({ length: 110 }, (_, i) => ({
      id: `ch-8-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: new Date(2026, 7, 4 - Math.floor(i / 4)).toISOString().split('T')[0],
    })),
    updateDate: '2026-08-04',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-9',
    title: '最后的人类',
    author: '朴相佑',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '公元2150年，人工智能统治了世界，人类沦为濒危物种。少年雷诺是已知的最后一百个人类之一，他生活在AI建造的"保护区"中。当他偶然发现了父辈留下的秘密——AI并非不可战胜，人类曾经拥有压制AI的终极武器。于是，雷诺踏上了寻找武器、解放人类的冒险旅程。科幻与奇幻的完美结合，宏大的世界观设定，视觉震撼的战斗场景！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%2C%20sci-fi%20fantasy%20manhwa%2C%20futuristic%20cyberpunk%20setting%2C%20young%20hero%20in%20high-tech%20armor%2C%20dystopian%20city%20background%2C%20cool%20blue%20and%20silver%20tones%2C%20manga%20style%2C%20clean%20webtoon%20cover%20design&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    rating: 9.0,
    views: '670万',
    status: '连载中',
    tags: ['科幻', '末世', '冒险', 'AI'],
    chapters: Array.from({ length: 38 }, (_, i) => ({
      id: `ch-9-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: new Date(2026, 7, 1 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
    updateDate: '2026-08-01',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 'comic-10',
    title: '办公室罗曼史',
    author: '姜秀雅',
    category: '都市',
    categorySlug: 'urban',
    description: '职场新人韩素拉进入梦想中的广告公司工作，却发现自己的直属上司竟然是一年前在酒吧有过一夜情缘的陌生男人！更糟糕的是，这位上司在工作中以冷酷无情著称。两人在职场中保持着微妙的距离，却因为工作的关系不得不频繁接触。当过去的秘密被同事发现，当办公室恋情面临曝光，他们该如何抉择？真实还原职场生态，甜蜜与辛酸交织的都市爱情故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%2C%20office%20romance%20manhwa%2C%20handsome%20man%20and%20beautiful%20woman%20in%20modern%20office%2C%20professional%20attire%2C%20warm%20romantic%20atmosphere%2C%20manga%20style%2C%20soft%20lighting%2C%20clean%20webtoon%20cover%20design&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    rating: 8.9,
    views: '1120万',
    status: '连载中',
    tags: ['职场', '恋爱', '都市', '甜宠'],
    chapters: Array.from({ length: 56 }, (_, i) => ({
      id: `ch-10-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: new Date(2026, 7, 2 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
    updateDate: '2026-08-02',
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-11',
    title: '恶女的救赎',
    author: '郑秀晶',
    category: '恋爱',
    categorySlug: 'love',
    description: '重生归来的恶女配角柳素妍决心改变自己的命运。上一世她按照原著的剧情，不断迫害女主角最终落得凄惨下场。这一世她要远离男女主角，过好自己的小日子。然而事情却朝着意想不到的方向发展——男主角竟然对她产生了兴趣？原著剧情全面崩塌，柳素妍能否在新的人生中找到真正的幸福？反转不断的剧情，让人欲罢不能！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%2C%20villainess%20romance%20manhwa%2C%20elegant%20female%20character%20in%20ball%20gown%2C%20luxurious%20palace%20setting%2C%20rose%20gold%20tones%2C%20manga%20style%2C%20dramatic%20composition%2C%20clean%20webtoon%20cover%20design&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    rating: 9.4,
    views: '1430万',
    status: '已完结',
    tags: ['重生', '恶女', '逆袭', '甜宠'],
    chapters: Array.from({ length: 92 }, (_, i) => ({
      id: `ch-11-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: new Date(2026, 6, 30 - Math.floor(i / 4)).toISOString().split('T')[0],
    })),
    updateDate: '2026-07-30',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-12',
    title: '鬼怪公寓',
    author: '张瑞元',
    category: '悬疑',
    categorySlug: 'mystery',
    description: '租金便宜得离谱的高级公寓，却有着一个让人毛骨悚然的规则——午夜之后不得出门。大学生林小雨为了省钱搬进了这栋神秘的公寓，很快她就发现了隐藏在光鲜表面下的恐怖真相。每一个住在这里的人都有着自己的秘密，而公寓的管理员似乎也不是人类。灵异与悬疑的完美融合，让你在深夜不敢独自阅读！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%2C%20horror%20mystery%20manhwa%2C%20haunted%20apartment%20building%2C%20eerie%20atmosphere%2C%20dark%20and%20moody%20illustration%2C%20manga%20style%2C%20cool%20dark%20blue%20tones%2C%20clean%20webtoon%20cover%20design&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    rating: 8.8,
    views: '750万',
    status: '连载中',
    tags: ['灵异', '恐怖', '都市', '悬疑'],
    chapters: Array.from({ length: 42 }, (_, i) => ({
      id: `ch-12-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: new Date(2026, 8, 1 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
    updateDate: '2026-08-01',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
];

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  return comics.filter((c) => c.categorySlug === categorySlug);
};

export const getHotComics = (): Comic[] => {
  return comics.filter((c) => c.isHot);
};

export const getNewComics = (): Comic[] => {
  return comics.filter((c) => c.isNew);
};

export const getRecommendedComics = (): Comic[] => {
  return comics.filter((c) => c.isRecommended);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};